import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import * as yup from "yup";
import { useSetMenu } from "../../../../hooks/useSetMenu";
import FormLayout from '../../../Generic/FormLayout';
import FormInput from '../../../Generic/FormInput';
import FormCheckbox from '../../../Generic/FormCheckbox';

const Add = () => {
  const { mainStore } = useStore();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  useSetMenu(mainStore.ResearchPublicationsAdminMenuType, mainStore.ResearchPublicationsAdminMenuNo);

  const [authors, setAuthors] = useState([""]);

  const onError = (errors, e) =>
    enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

  const schema = yup.object({
    title: yup.string().required(t('requiredField')).max(500, t('maxLength', { max: 500 })),
    year: yup.number().required(t('requiredField')).min(1900, t('minValue', { min: 1900 })),
    category: yup.string().required(t('requiredField')),
    publicationOrder: yup.number().required(t('requiredField')).min(1, t('minValue', { min: 1 })),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      publicationOrder: 1,
      year: new Date().getFullYear(),
      isVisible: true,
    }
  });

  const handleAddAuthor = () => {
    setAuthors([...authors, ""]);
  };

  const handleRemoveAuthor = (index) => {
    const newAuthors = authors.filter((_, i) => i !== index);
    setAuthors(newAuthors.length > 0 ? newAuthors : [""]);
  };

  const handleAuthorChange = (index, value) => {
    const newAuthors = [...authors];
    newAuthors[index] = value;
    setAuthors(newAuthors);
  };

  const sendData = async (data) => {
    try {
      const payload = {
        ...data,
        authors: authors.filter(a => a.trim() !== ""),
      };
      await axiosPrivate.post("/ResearchPublications", payload);
      enqueueSnackbar(t("successAdd"), { variant: "success" });
      navigate("/Admin/ResearchPublications");
    } catch (error) {
      enqueueSnackbar(t("errorAdd"), { variant: "error" });
    }
  };

  const onSubmit = data => sendData(data);
  const onCancel = () => navigate(-1);

  return (
    <FormLayout title={t("researchPublicationCreateTitle") || "Add Research Publication"} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
      <FormInput label="order" name="publicationOrder" type="number" register={register} errors={errors} colSize={2} />
      <FormInput label="year" name="year" type="number" register={register} errors={errors} colSize={2} />
      <FormInput label="category" name="category" register={register} errors={errors} colSize={4} />
      <FormInput label="title" name="title" register={register} errors={errors} colSize={12} />
      <FormInput label="venue" name="venue" register={register} errors={errors} colSize={8} />
      <FormInput label="venueDate" name="venueDate" register={register} errors={errors} colSize={4} />
      <FormInput label="doi" name="doi" register={register} errors={errors} colSize={6} />
      <FormInput label="url" name="url" register={register} errors={errors} colSize={6} />

      <div className="col-12 mb-3">
        <label className="form-label">{t("authors")}</label>
        {authors.map((author, index) => (
          <div key={index} className="input-group mb-2">
            <input
              type="text"
              className="form-control"
              value={author}
              onChange={(e) => handleAuthorChange(index, e.target.value)}
              placeholder={t("authorName")}
            />
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => handleRemoveAuthor(index)}
            >
              <i className="bi bi-trash"></i>
            </button>
          </div>
        ))}
        <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleAddAuthor}>
          <i className="bi bi-plus"></i> {t("addAuthor")}
        </button>
      </div>

      <FormInput label="descriptionEN" name="descriptionEN" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionBG" name="descriptionBG" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionSQ" name="descriptionSQ" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormCheckbox label="isVisible" register={register} name="isVisible" colSize={4} />
    </FormLayout>
  );
};

export default Add;
